import {JSX, JSXElement, splitProps} from "solid-js";
import css from "./page.module.css";
import {Meta, Title} from "@solidjs/meta";

interface PageProps extends JSX.HTMLAttributes<HTMLElement> {
    children: JSXElement | JSXElement[];
    metaTitle?: string
    metaDescription?: string
}

export default function Page(props: PageProps) {
    const [local, rest] = splitProps(props, ["class", "children", "metaTitle", "metaDescription"]);

    const brand = "Graceful Space Yoga"
    const description = "Breathe. Flow. Reconnect. Join Graceful Space Yoga for Vinyasa flow classes in Catshill Village Hall. Book online and discover your yoga journey."

    return (
        <>
            <Title>{local.metaTitle ? `${local.metaTitle} | ${brand}` : brand}</Title>
            <Meta name="description"
                  content={local.metaDescription ? local.metaDescription : description}/>
            <main
                class={`${css.page} ${local.class || ""}`.trim()}
                {...rest}
            >
                {local.children}
            </main>
        </>
    );
}